import React, { useRef } from 'react';
import { useParams } from 'react-router-dom';
import Canvas from '../../components/Canvas/index';
import LabsAppBar, { ActionButton, TabItem } from '../../components/LabsAppBar';

const TagMapPage: React.FC = () => {
  const { domain } = useParams<{ domain?: string }>();
  const containerRef = useRef<HTMLDivElement>(null);

  // Define breadcrumbs and actions for LabsAppBar
  const breadcrumbs = [
    { name: 'Website Scans', iconName: 'FileChartColumn', path: '/labs/chrome-extension' },
    { name: domain ? `Scan Summary: ${domain}` : 'Scan Summary', path: domain ? `/labs/chrome-extension/${domain}` : '/labs/chrome-extension' },
    { name: 'Tag Map' }
  ];

  const actions: ActionButton[] = [
    { 
      label: 'Back to Scans', 
      onClick: () => window.location.href = '/labs/chrome-extension', 
      iconName: 'ArrowLeft', 
      variant: 'secondary' 
    }
  ];

  // Define tabs for LabsAppBar
  const tabs: TabItem[] = [
    { label: 'Scan Overview', path: domain ? `/labs/chrome-extension/${domain}` : '/labs/chrome-extension' },
    { label: 'Tag Map', path: domain ? `/labs/chrome-extension/${domain}/tag-map` : '/labs/chrome-extension/tag-map' }
  ];

  return (
    <div className="flex flex-col h-full">
      <LabsAppBar breadcrumbs={breadcrumbs} actions={actions} tabs={tabs} />
      <div className="flex-1 overflow-hidden" ref={containerRef}>
        <Canvas mode="project" />
      </div>
    </div>
  );
};

export default TagMapPage;
